var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolbar1",style:({ right: _vm.right })})
}
var staticRenderFns = []

export { render, staticRenderFns }